import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box, TextField } from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import { UTextField } from "@/components/index"
export const PrintOthers = () => {
  const {
    clinicalSettings: {
      GenerateShell,
      DrainHole,
      ShellThickness,
      PrintDirection,
      HeightOfWall,
    },
  } = useAppSelector((state: RootState) => state.userService)
  const dispatch = useAppDispatch()
  // hollow model
  const [hollowModel, setHollowModel] = useState<number>(0)
  const handleHollowModel = (event: React.ChangeEvent<HTMLInputElement>) => {
    setHollowModel(+(event.target as HTMLInputElement).value)
  }
  // Drain hole
  const [drainHole, setDrainHole] = useState<number>(0)
  const handleDrainHole = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDrainHole(+(event.target as HTMLInputElement).value)
  }
  // Thickness
  const [thickness, setThickness] = useState<number | string>(0)
  const handleInput = (
    e: React.ChangeEvent<HTMLInputElement>,
    min: number,
    max: number,
    setVal: (arg: string | number) => void,
  ) => {
    let value = e.target.value
      .replace(/[^0-9.]/g, "") // 移除非数字和小数点
      .replace(/(\..*)\./g, "$1") // 禁止多个小数点
      .replace(/^\./, `${min}.`) // 处理单独的小数点开头
      .replace(/(\.\d{1})\d+$/, "$1") // 限制一位小数

    // 格式验证和范围修正
    if (/^\d*\.?\d*$/.test(value) && value !== "") {
      const numValue = parseFloat(value)

      if (numValue < min) {
        value = `${min}.0`
      } else if (numValue > max) {
        value = `${max}.0`
      }
    }
    setVal(value)
  }
  const handleBlurThick = () => {
    if (thickness) {
      const num = parseFloat(thickness)
      setThickness(num % 1 === 0 ? num.toString() : num.toFixed(1)) // 失焦格式化
    }
  }
  const handleBlurHeight = () => {
    if (heightModel) {
      const num = parseFloat(heightModel)
      setHeightModel(num % 1 === 0 ? num.toString() : num.toFixed(1)) // 失焦格式化
    }
  }
  // Print direction
  const [printDirection, setPrintDirection] = useState<number>(1)
  const handlePrintDirection = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPrintDirection(+(event.target as HTMLInputElement).value)
  }

  // Height model
  const [heightModel, setHeightModel] = useState<number | string>()

  useEffect(() => {
    if (GenerateShell !== "") {
      setHollowModel(GenerateShell)
    }
    if (DrainHole !== "") {
      setDrainHole(DrainHole)
    }
    if (ShellThickness !== "") {
      setThickness(ShellThickness)
    }
    if (PrintDirection !== "") {
      setPrintDirection(PrintDirection)
    }
    if (HeightOfWall !== "") {
      setHeightModel(HeightOfWall)
    }
  }, [])
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          //   width: "100%",
          display: "flex",
          margin: "20px 85px 0 0",
          justifyContent: "space-between",
        }}
      >
        <Box id="other1" sx={{ display: "flex", flexDirection: "column" }}>
          <FormControl sx={{ marginBottom: "12px" }}>
            <FormLabel id="hollow">{`Hollow the model`}</FormLabel>
            <RadioGroup
              row
              sx={{
                marginLeft: "8px",
                "& .MuiFormControlLabel-root": {
                  marginRight: "30px",
                },
              }}
              aria-labelledby="hollow"
              name="radio-buttons-group"
              value={hollowModel}
              onChange={handleHollowModel}
            >
              <FormControlLabel value={1} control={<Radio />} label="Yes" />
              <FormControlLabel value={0} control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
          <FormControl sx={{ marginBottom: "12px" }}>
            <FormLabel>{`Drain hole`}</FormLabel>
            <RadioGroup
              row
              name="radio-buttons-group"
              sx={{
                marginLeft: "8px",
                "& .MuiFormControlLabel-root": {
                  marginRight: "30px",
                },
              }}
              value={drainHole}
              onChange={handleDrainHole}
            >
              <FormControlLabel value={1} control={<Radio />} label="Yes" />
              <FormControlLabel value={0} control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
          <FormControl>
            <FormLabel>{`Thickness of model(mm)`}</FormLabel>
            <TextField
              sx={{
                width: "100px",
                marginLeft: "10px",
                marginTop: "6px",
                "& .MuiInputBase-input": { padding: "8px 14px" },
              }}
              value={thickness}
              onChange={(e) => {
                handleInput(e, 2, 3, setThickness)
              }}
              onBlur={handleBlurThick}
            />
          </FormControl>
        </Box>
        <Box id="other2" sx={{ display: "flex", flexDirection: "column" }}>
          <FormControl sx={{ marginBottom: "12px" }}>
            <FormLabel id="printDirection">{`Print direction`}</FormLabel>
            <RadioGroup
              row
              sx={{
                marginLeft: "8px",
                "& .MuiFormControlLabel-root": {
                  marginRight: "30px",
                },
              }}
              aria-labelledby="printDirection"
              name="radio-buttons-group"
              value={printDirection}
              onChange={handlePrintDirection}
            >
              <FormControlLabel
                value={0}
                control={<Radio />}
                label="Horizontal"
              />
              <FormControlLabel
                value={1}
                control={<Radio />}
                label="Vertical"
              />
            </RadioGroup>
          </FormControl>
        </Box>
        <Box id="other3" sx={{ display: "flex", flexDirection: "column" }}>
          <FormControl>
            <FormLabel>{`Height of model base(mm)`}</FormLabel>
            <TextField
              sx={{
                width: "100px",
                marginLeft: "10px",
                marginTop: "6px",
                "& .MuiInputBase-input": { padding: "8px 14px" },
              }}
              value={heightModel}
              onChange={(e) => {
                handleInput(e, 1, 20, setHeightModel)
              }}
              onBlur={handleBlurHeight}
            />
          </FormControl>
        </Box>
      </Box>
    </Box>
  )
}
